/**
 * MOCK SUPABASE CLIENT
 * Used temporarily to prevent compilation errors while migrating to Django REST API.
 * DO NOT USE FOR NEW CODE. Use `apiGet`, `apiPost`, etc. from `src/integrations/api/client.ts`.
 */

export function getSupabase(): any {
  console.warn("Legacy Supabase client called. This should be migrated to Django API.");
  return {
    auth: {
      getSession: async () => ({ data: { session: null }, error: null }),
      signInWithPassword: async () => ({ data: { user: {} }, error: null }),
      signOut: async () => ({ error: null }),
    },
    from: (table: string) => ({
      select: () => ({ eq: () => ({ in: () => Promise.resolve({ data: [], error: null }) }) }),
      insert: () => ({ select: () => ({ single: () => Promise.resolve({ data: {}, error: null }) }) }),
      update: () => ({ eq: () => Promise.resolve({ data: {}, error: null }) }),
      delete: () => ({ eq: () => Promise.resolve({ data: {}, error: null }) }),
    }),
    storage: {
      from: () => ({
        createSignedUrl: async () => ({ data: { signedUrl: "" }, error: null }),
        upload: async () => ({ error: null }),
        remove: async () => ({ error: null }),
      }),
    }
  };
}

export function getSupabaseAdmin(): any {
  return getSupabase();
}
